const headers = [{
    label: 'Symbol',
    sortValue: 'symbol'
},
    {
    label: 'Direction',
    sortValue: 'direction'
},
    {
        label: 'Type',
        sortValue: 'type'
    },
    {
        label: 'Date added',
        sortValue: 'dateAdded'
    }, {
        label: 'Last update',
        sortValue: 'lastUpdate'
    },
    {
        label: 'Price change',
        sortValue: 'changeSincePublished'
    },
    {
        label: 'Followups',
        sortValue: 'numOfFollowups'
    }, {
        label: 'Actions',
        sortValue: 'isHighlight'
    }];

export default headers;
